import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

/**
 * The section cards themselves are `ext-ui`'s `Box` — its `default` variant is
 * the bordered, shadowless container the design calls for, and its 20px/24px
 * padding matches the spec exactly. Only the stack between them lives here.
 */
export const sections = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(9)};
`
